
import React from 'react';
import { Trophy, Crown, Star } from 'lucide-react';
import GameCard from '../game/GameCard';
import { useTopGames } from '@/hooks/useTopGames';

const TopGamesSection: React.FC = () => {
  const { data: topGames, isLoading } = useTopGames();

  if (isLoading) {
    return (
      <section className="mb-16">
        <div className="flex items-center space-x-4 mb-8">
          <div className="w-1 h-12 bg-gradient-to-b from-yellow-500 to-orange-600 rounded-full"></div>
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1">
              🏆 Top Games
            </h2>
            <p className="text-gray-600 font-medium">
              Our most popular and highest-rated games
            </p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-8 gap-3 md:gap-4 lg:gap-6">
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="animate-pulse">
              <div className="bg-gray-200 w-full aspect-square rounded-lg mb-2"></div>
              <div className="bg-gray-200 h-4 rounded mb-1"></div>
              <div className="bg-gray-200 h-3 rounded w-3/4"></div>
            </div>
          ))}
        </div>
      </section>
    );
  }

  if (!topGames || topGames.length === 0) {
    return null;
  }

  return (
    <section className="mb-16">
      <div className="flex items-center space-x-4 mb-8">
        <div className="w-1 h-12 bg-gradient-to-b from-yellow-500 to-orange-600 rounded-full"></div>
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1 flex items-center gap-2">
            <Trophy className="w-6 h-6 text-yellow-600" />
            Top Games
          </h2>
          <p className="text-gray-600 font-medium">
            Our most popular and highest-rated games
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-8 gap-3 md:gap-4 lg:gap-6">
        {topGames.map((game, index) => (
          <div key={game.id} className="relative animate-fade-in" style={{ animationDelay: `${index * 100}ms` }}>
            {index < 3 && (
              <div className="absolute -top-2 -left-2 z-10">
                <div className={`w-6 h-6 md:w-8 md:h-8 rounded-full flex items-center justify-center text-white text-xs font-bold shadow-lg ${
                  index === 0 ? 'bg-gradient-to-r from-yellow-400 to-yellow-600' :
                  index === 1 ? 'bg-gradient-to-r from-gray-400 to-gray-600' :
                  'bg-gradient-to-r from-orange-400 to-orange-600'
                }`}>
                  {index === 0 ? <Crown className="w-3 h-3 md:w-4 md:h-4" /> : 
                   index === 1 ? <Star className="w-3 h-3 md:w-4 md:h-4" /> : 
                   <Trophy className="w-2 h-2 md:w-3 md:h-3" />}
                </div>
              </div>
            )}
            <GameCard 
              game={game} 
              size="small"
              priority={index < 4}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default TopGamesSection;
